import React, { useEffect } from "react";
import "./style.scss";
import classEdge from "../../images/Tata-Class-Edge.png";
// import logoWhite from "../../images/logo.png";

export default function Sitemap() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://platform.twitter.com/widgets.js";
    document
      .getElementsByClassName("sitemap__twittercontainer")[0]
      .appendChild(script);
  }, []);
  return (
    <div className="sitemap">
      <div className="sitemap__linkscontainer">
        <div className="row">
          <div className="col col-12 col-lg-8 sitemap__linkscontainer__leftsection">
            <div className="row sitemap__linkscontainer__row">
              <div className="col col-6 col-md-4 col-lg-3">
                <div className="sitemap__linkscontainer__card">
                  <div className="sitemap__linkscontainer__card__heading">
                    Quick Links
                  </div>

                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/contact-information/">Contact Information</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/careers/">Careers</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/alumni/">Alumni</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/online-registration-process/">
                      Online Fee Payment
                    </a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://cvvv.iwsportal.com:572/Account/Login.aspx"
                    >
                      Parent Portal
                    </a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="http://cbse.nic.in/">CBSE Website</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/cbse-results/">Achievers</a>
                  </div>
                </div>
              </div>
              <div className="col col-6 col-md-4 col-lg-3">
                <div className="sitemap__linkscontainer__card">
                  <div className="sitemap__linkscontainer__card__heading">
                    About
                  </div>

                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/chinmaya-mission-trust/"> Chinmaya Mission</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/chinmaya-vision-programme/">
                      Chinmaya Vision Program
                    </a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/gurudevs-journey">Gurudev's Journey</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/principal-message/">Principal's Message</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/managing-committee/">Managing Committee</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/hall-of-fame/">School Awards</a>
                  </div>
                </div>
              </div>
              <div className="col col-6 col-md-4 col-lg-3">
                <div className="sitemap__linkscontainer__card">
                  <div className="sitemap__linkscontainer__card__heading">
                    School Information
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/cbse-corner/">CBSE Corner</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/transfer-certificate/">Transfer Certificate</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/rules-and-regulations/">Rules & Regulations</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/transportation/">Transportation</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/school-calendar/">School Calendar</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/school-uniform/">School Uniform</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/infrastructure/">Infrastructure</a>
                  </div>
                </div>
              </div>
              <div className="col col-6 col-md-4 col-lg-3">
                <div className="sitemap__linkscontainer__card">
                  <div className="sitemap__linkscontainer__card__heading">
                    Academics
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/cbse-results/">CBSE Results</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/syllabus/">Syllabus</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/subjects/">Subjects</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="#">Exam Schedule</a>
                  </div>
                </div>
              </div>
              <div className="col col-6 col-md-4 col-lg-3">
                <div className="sitemap__linkscontainer__card">
                  <div className="sitemap__linkscontainer__card__heading">
                    Co-Curriculars
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/laboratories/">Laboratories</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/performance-arts/">Performance Arts</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/sports/">Sports</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="#">Signature Activities</a>
                  </div>
                </div>
              </div>
              <div className="col col-6 col-md-4 col-lg-3">
                <div className="sitemap__linkscontainer__card">
                  <div className="sitemap__linkscontainer__card__heading">
                    Admissions
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/nursery-admissions/">Nursery</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/admissions/">Other Classes</a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/online-registration-process/">
                      Application Process
                    </a>
                  </div>
                  <div className="sitemap__linkscontainer__card__link">
                    <a href="/registrations/">Registrations</a>
                  </div>
                </div>
              </div>
              <div className="sitemap__images">
                <img
                  className="sitemap__images__img"
                  alt=""
                  src="https://www.chinmayavvdelhi.ac.in/images/Blackele/cce1_1.png"
                ></img>

                <img
                  className="sitemap__images__img"
                  alt=""
                  src="https://chinmayavvdelhi.ac.in/assets/images/school-awards-logo.jpg"
                ></img>
                {/* <img
                  className="sitemap__images__img"
                  alt=""
                  src="https://www.chinmayavvdelhi.ac.in/images/Blackele/extramarks1_3.png"
                ></img>
                <img
                  className="sitemap__images__img"
                  alt=""
                  src="https://www.chinmayavvdelhi.ac.in/images/Blackele/rotary1_4.png"
                ></img>
                <img
                  className="sitemap__images__img"
                  alt=""
                  src={classEdge}
                ></img> */}
              </div>
            </div>
          </div>
          <div className="col col-12 col-lg-4 sitemap__linkscontainer__rightsection">
            <div className="sitemap__twittercontainer">
              <iframe
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fchinmayavidyalayavv%2F&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=729337057890868"
                width="340"
                height="500"
                style={{
                  border: "none",
                  overflow: "hidden",
                  marginLeft: "auto",
                }}
                scrolling="no"
                frameborder="0"
                allowfullscreen="true"
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
